const elements = document.querySelectorAll('[data-replace-after-load-from-url]');

elements.forEach(element => {
    const url = element.getAttribute('data-replace-after-load-from-url');

    if (url) {
        if (element.tagName === 'IMG' || element.tagName === 'IFRAME' || element.tagName === 'SCRIPT' || element.tagName === 'LINK') {
            if (element.complete || element.readyState === 'complete' || element.readyState === 'loaded') {
                // Element je již načten
                fetchAndReplaceElement(element, url);
            } else {
                // Přidání event listeneru na událost `load`
                element.addEventListener('load', () => {
                    fetchAndReplaceElement(element, url);
                });
            }
        } else {
            // For elements that don't have a native load event, assume they are already loaded
            fetchAndReplaceElement(element, url);
        }
    }
});

function fetchAndReplaceElement(element, url) {
    fetch(url)
        .then(response => response.text())
        .then(data => {
            const tempElement = document.createElement('div');
            tempElement.innerHTML = data;

            // Replace the element with its fetched content
            while (tempElement.firstChild) {
                element.parentNode.insertBefore(tempElement.firstChild, element);
            }
            element.parentNode.removeChild(element);
        })
        .catch(error => {
            console.error('Error loading content from URL:', error);
        });
}
